import { __assign } from "tslib";
import { v4 as uuidv4 } from 'uuid';
import { createTheme as createThemeMui } from '@mui/material/styles';
import createDefaultTheme from './theme';
import { ThemeModes } from './variables';
var GlobalTheme = /** @class */ (function () {
    function GlobalTheme() {
    }
    Object.defineProperty(GlobalTheme, "isLoaded", {
        get: function () {
            return this._loaded;
        },
        enumerable: false,
        configurable: true
    });
    GlobalTheme.init = function (lightTheme, darkTheme, mode) {
        var _a;
        if (mode === void 0) { mode = ThemeModes.Light; }
        GlobalTheme.clear();
        this._setTheme((_a = {},
            _a[ThemeModes.Light] = createThemeMui(lightTheme),
            _a[ThemeModes.Dark] = darkTheme ? createThemeMui(darkTheme) : undefined,
            _a.mode = mode,
            _a));
        this._loaded = true;
    };
    GlobalTheme.getTheme = function () {
        var _a, _b;
        var mode = ((_a = this._getTheme()) === null || _a === void 0 ? void 0 : _a.mode) || ThemeModes.Light;
        return ((_b = this._getTheme()) === null || _b === void 0 ? void 0 : _b[mode]) || createDefaultTheme(mode);
    };
    GlobalTheme.setMode = function (mode) {
        if (mode === void 0) { mode = ThemeModes.Light; }
        this._setTheme(__assign(__assign({}, this._getTheme()), { mode: mode }));
        GlobalTheme._$listeners.forEach(function (_a) {
            var cb = _a.cb;
            return cb(mode);
        });
    };
    GlobalTheme.getMode = function () {
        var _a;
        return ((_a = this._getTheme()) === null || _a === void 0 ? void 0 : _a.mode) || ThemeModes.Light;
    };
    GlobalTheme.register = function (cb) {
        var id = uuidv4();
        GlobalTheme._$listeners.push({ id: id, cb: cb });
        return id;
    };
    GlobalTheme.unregister = function (identifier) {
        if (!identifier) {
            return;
        }
        GlobalTheme._$listeners = GlobalTheme._$listeners.filter(function (_a) {
            var id = _a.id;
            return id !== identifier;
        });
    };
    GlobalTheme.clear = function () {
        delete window[GlobalTheme._name];
        this._$listeners = [];
        this._loaded = false;
    };
    GlobalTheme._name = "".concat(process.env.REACT_APP_LIB_NAME, "_GlobalTheme");
    GlobalTheme._loaded = false;
    GlobalTheme._$listeners = [];
    GlobalTheme._setTheme = function (data) {
        ;
        window[GlobalTheme._name] = data;
    };
    GlobalTheme._getTheme = function () {
        return window[GlobalTheme._name] || null;
    };
    return GlobalTheme;
}());
export default GlobalTheme;
//# sourceMappingURL=global.js.map